import { config } from './config';
import { fetchWrapper } from './fetchWrapper';

const baseUrlV1 = `${config.apiUrl}`;
const baseUrlV2 = `${config.apiUrlV2}`;
const authUrl = `${config.authUrl}`;

export const allService = {
  getAll,
  getAllWithoutToken,
  getPaymentLink,
  paymentLinkInit,
  getById,
  create,
  update,
  delete: _delete,
  registerOrLogin,
  VerifyMenuAccess,
  VerifyButtonAccess,
  validateEmail,
  checkPasswordMatch,
  createAuth,
  updateAuth,
  updateTransac,
  empty,
  numberWithCommas,
  validateOperatorPhone,
  validateOrangePhone,
  validateNextelPhone,
  validateCamtelPhone,
  validateMtnPhone,
  chunk,
  validateMtnPhone,
  validateCamtelBlue,
  validateOperatorRegExp,
};

function empty(e) {
  switch (e) {
    case '':
    case null:
    case undefined:
      return true;
    default:
      return false;
  }
}

function getAllWithoutToken(entity) {
  return fetchWrapper.getWithOutToken(`${baseUrlV1}/${entity}`);
}

function getPaymentLink(token) {
  return fetchWrapper.getWithOutToken(
    `${baseUrlV2}/payment-links/show-links/web/${token}`,
  );
}

function paymentLinkInit(data) {
  return fetchWrapper.post(`${baseUrlV2}/payment-links/pay-with-link`, data);
}

function getAll(entity, token) {
  return fetchWrapper.get(`${baseUrlV1}/${entity}`, token);
}

function getById(id, entity, token) {
  return fetchWrapper.get(`${baseUrlV1}/${entity}/${id}`, token);
}

function create(params, entity, token) {
  return fetchWrapper.post(`${baseUrlV1}/${entity}`, params, token);
}

//Function call for auth api
function registerOrLogin(params, entity) {
  return fetchWrapper.login(`${authUrl}/${entity}`, params);
}

function createAuth(params, entity, token) {
  return fetchWrapper.post(`${authUrl}/${entity}`, params, token);
}

function updateAuth(id, params, entity, token) {
  return fetchWrapper.put(`${authUrl}/${entity}/${id}`, params, token);
}
//

function update(id, params, entity, action, token) {
  return fetchWrapper.put(
    `${baseUrlV1}/${entity}/${id}/${action}`,
    params,
    token,
  );
}

function updateTransac(params, entity, token) {
  return fetchWrapper.put(`${baseUrlV1}/${entity}`, params, token);
}

function _delete(id, entity, action, token) {
  return fetchWrapper.delete(`${baseUrlV1}/${entity}/${id}/${action}`, token);
}

function VerifyMenuAccess(ressource, permissions) {
  let permission = permissions
    ? permissions.find((p) => p.ressource === ressource)
    : false;
  if (permission) {
    if (
      permission.abilities.includes('READ') ||
      permission.abilities.includes('MANAGE')
    ) {
      return true;
    }
  }
  return false;
}

function VerifyButtonAccess(ressource, ability, permissions) {
  let permission = permissions
    ? permissions.find((p) => p.ressource === ressource)
    : false;
  if (permission) {
    if (permission.abilities.includes(ability)) {
      return true;
    }
  }
  return false;
}

function validateEmail(text) {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w\w+)+$/;
  if (reg.test(text) === false) {
    return false;
  } else {
    return true;
  }
}

function checkPasswordMatch(pass1, pass2) {
  if (pass1 !== pass2) {
    return false;
  } else {
    return true;
  }
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function validateOperatorRegExp(regExp, phone) {
  return !regExp ? false : new RegExp(regExp).test(phone);
}

function validateOperatorPhone(operator, phone) {
  var re = '';

  switch (operator) {
    case 'ORANGE':
      re = /^[6]([9][0-9]|[5][5,6,7,8,9])[0-9]{6}$/;
      break;
    case 'MTN':
      re = /^[6]([7][0-9]|[5][0,1,2,3,4])[0-9]{6}|[6]([8][0])([0-9]){6}$/;
      break;
    case 'CAMTEL':
      re =
        /^[2]([2][2]|[3][3]|[4][2]|[4][3])([0-9]){6}|[6]([2][0]|[2][1])([0-9]){6}$/;
      break;
    case 'NEXTEL':
      re = /^[6][6]([0-9]){7}$/;
      break;
  }

  return re === '' ? false : re.test(phone);
}

function validateOrangePhone(str) {
  //const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const re = /^[6]([9][0-9]|[5][5,6,7,8,9])[0-9]{6}$/;
  return re.test(str);
}

function validateMtnPhone(str) {
  //const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const re = /^[6]([7][0-9]|[5][0,1,2,3,4])[0-9]{6}$/;
  return re.test(str);
}

function validateNextelPhone(str) {
  //const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const re = /^[6][6]([0-9]){7}$/;
  return re.test(str);
}

function validateCamtelPhone(str) {
  //const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const re = /^[2]([2][2]|[3][3]|[4][2]|[4][3])([0-9]){6}$/;
  return re.test(str);
}

function chunk(str, n, tojoin) {
  var ret = [];
  var i;
  var len;

  for (i = 0, len = str.length; i < len; i += n) {
    ret.push(str.substr(i, n));
  }

  return ret.join(tojoin);
}

function validateCamtelBlue(str) {
  //const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const re = /^[6]([2][0])([0-9]){6}$/;
  return re.test(str);
}
